/** Отображаемое имя и пути для сообщений от компании / AI-ассистента */
export const CLEVERENCE_AUTHOR = "Клеверенс";
export const CLEVERENCE_AVATAR_URL = "/cleverence-avatar.webp";

/** Имена из ETL (канал Telegram) и live-ответов AI */
const CLEVERENCE_ALIASES = [
  "клеверенс",
  "cleverence",
  "команда cleverence",
  "команда клеверенс",
] as const;

export function isCleverenceAuthor(author: string): boolean {
  const a = author.trim().toLowerCase();
  if (a === CLEVERENCE_AUTHOR.toLowerCase()) return true;
  return CLEVERENCE_ALIASES.some((alias) => a === alias || a.includes(alias));
}
